export const IN_RESERVATION = {
    IN_RES_ACCELERATE_CHECK_IN_SAVE_TIME: 'IN_RES_ACCELERATE_CHECK_IN_SAVE_TIME',
};